const swiperSimpleSingleImage = {
    swiperInstance: null,
    init: () => {
        import('swiper/bundle').then(({Swiper}) => {
            let domEls = document.querySelectorAll('.js-swiper-simple-single-image');
            if (domEls) {
                const params = getSwiperParams();
                domEls.forEach(el => {
                    swiperSimpleSingleImage.swiperInstance = new Swiper(el, params);
                })
            }
        })
    }
};

const getSwiperParams = () => {

    return {
        watchOverflow: true,
        centeredSlides: false,
        spaceBetween: 32,
        slidesPerView: 1,
        slideToClickedSlide: true,
        resizeObserver: true,
        a11y: true,
        mousewheel: {
            forceToAxis: true
        },
        grabCursor: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    }
}

export default swiperSimpleSingleImage;